var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path2, _path3, _path4, _path5, _path6, _polygon, _path7, _polygon2, _polyline, _polygon3, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "198.09 443.75 198.09 483.19 255.77 483.19 319.38 483.19 319.38 443.75 198.09 443.75",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193 432.72 193 443.75 323.62 443.75 323.62 432.72 255.77 432.72 193 432.72",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.31 483.19 319.38 483.19 319.38 443.75 323.62 443.75 323.62 432.72 255.77 432.72 255.77 442.73 258.31 483.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.06,
    y: 450.11,
    width: 24.6,
    height: 5.94,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.89,
    y: 463.47,
    width: 31.58,
    height: 12.54,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.13 393.33 207.13 432.77 264.81 432.77 328.42 432.77 328.42 393.33 207.13 393.33",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.62 382.31 202.62 393.33 333.24 393.33 333.24 382.31 265.39 382.31 202.62 382.31",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.35 432.77 329 432.77 329 393.33 332.66 393.33 332.66 382.31 264.81 382.31 264.81 392.31 267.35 432.77",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.09,
    y: 399.7,
    width: 24.6,
    height: 5.94,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.93,
    y: 413.05,
    width: 31.58,
    height: 12.54,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.8,
    y: 32.27,
    width: 147.55,
    height: 213.86,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.41,
    y: 32.27,
    width: 147.55,
    height: 213.86,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.74,
    y: 55.43,
    width: 110.88,
    height: 167.54,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.62,223s0-.29,0-.82,0-1.34,0-2.38c0-2.1,0-5.18-.05-9.19,0-8,0-19.73-.1-34.51,0-29.54-.1-71.38-.18-120.64l.37.37-110.87,0h0l.4-.4c0,63.2-.06,121.48-.08,167.54l-.32-.32,80.71.17,22.29.08,5.86,0c1.32,0,2,0,2,0s-.65,0-1.95,0l-5.8,0-22.22.08-80.91.17h-.32V223c0-46.06-.05-104.34-.08-167.54V55h.41l110.87,0H430v.37c-.07,49.36-.14,91.28-.18,120.88,0,14.75-.08,26.42-.1,34.43,0,4,0,7,0,9.12,0,1,0,1.79,0,2.33S429.62,223,429.62,223Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.37,32.27a27,27,0,0,1-2.63,3.82c-1.72,2.29-4.15,5.41-6.93,8.78s-5.37,6.36-7.29,8.48a26,26,0,0,1-3.24,3.31A26.65,26.65,0,0,1,431.09,53c2-2.4,4.41-5.36,7.11-8.62s5.12-6.22,7.09-8.62A27.54,27.54,0,0,1,448.37,32.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.19,222.43a137,137,0,0,0,19.34,24.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.53,246.62a22.13,22.13,0,0,1-3.38-3.07,108.29,108.29,0,0,1-13.71-17.16,21.48,21.48,0,0,1-2.25-4,31,31,0,0,1,2.72,3.64c1.62,2.29,3.91,5.41,6.58,8.75s5.21,6.25,7.08,8.34A30.08,30.08,0,0,1,449.53,246.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.38,246l19.33-23.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.71,222.12c.17.14-4,5.59-9.35,12.17s-9.8,11.81-10,11.67,4-5.59,9.36-12.17S319.54,222,319.71,222.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.41,32.27c.17-.14,4.37,4.88,9.38,11.21s8.92,11.58,8.75,11.71-4.38-4.88-9.38-11.21S300.23,32.4,300.41,32.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.95,
    y: 89.45,
    width: 37.13,
    height: 105.42,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.6,483.53c0,.15-98.21.26-219.33.26s-219.35-.11-219.35-.26,98.18-.26,219.35-.26S469.6,483.39,469.6,483.53Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Book--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46,286.79s17,14.31,19.82,14.1a28.53,28.53,0,0,1,5.74.26L53.29,284.26Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.47,308.78,67.34,301.26a4,4,0,0,1-3.83-4.18c2.92-95.36,7.65-208.54,10.38-242a4,4,0,0,1,4.18-3.72l173.25,7.52a4,4,0,0,1,3.84,4.24l-10.5,241.76A4.06,4.06,0,0,1,240.47,308.78Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.22 304.96 65.3 298.72 51.67 288.28 59.88 40.6 239 52.81 247.85 62.73 238.22 304.96",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.22 304.96 222.13 290.57 236.09 50.27 247.85 62.73 238.22 304.96",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.38,295.78,48.9,288.16A4.06,4.06,0,0,1,45,284c2.9-95.37,7.63-208.54,10.38-242a4.06,4.06,0,0,1,4.23-3.72l175.61,7.62a4.08,4.08,0,0,1,3.89,4.24L228.62,291.9A4.07,4.07,0,0,1,224.38,295.78Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.07,288.65c-.15,0,2.14-55.44,5.11-123.8s5.5-123.79,5.64-123.78S68.67,96.5,65.7,164.88,60.21,288.65,60.07,288.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.23,282.22l-141.3-6.13L81.7,51.16,223,57.3Zm-137.13-10,133.31,5.79,9.42-216.93L85.52,55.33Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 126.93,
    y: 258.79,
    width: 29.53,
    height: 8.28,
    transform: "translate(11.54 -5.9) rotate(2.49)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 146.65,
    y: 67.18,
    width: 13.76,
    height: 8.28,
    transform: "translate(3.24 -6.6) rotate(2.49)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 97.88,
    y: 104.66,
    width: 103.7,
    height: 36.97,
    transform: "translate(5.48 -6.38) rotate(2.49)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 108.01,
    y: 151.63,
    width: 76.37,
    height: 15.57,
    transform: "matrix(1, 0.04, -0.04, 1, 7.05, -6.19)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 53.01,
    y: 73.21,
    width: 10.62,
    height: 6.69,
    transform: "translate(3.38 -2.46) rotate(2.49)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 52.56,
    y: 83.54,
    width: 10.62,
    height: 6.69,
    transform: "translate(3.82 -2.43) rotate(2.49)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 45.59,
    y: 262.22,
    width: 9.83,
    height: 6.69,
    transform: "translate(11.57 -1.94) rotate(2.49)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 49.11,
    y: 108.64,
    width: 10.62,
    height: 115.06,
    transform: "translate(7.26 -2.2) rotate(2.49)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M243.44,58.55s0,.36,0,1.08-.06,1.78-.11,3.16c-.11,2.79-.27,6.88-.48,12.16-.44,10.56-1.08,25.84-1.86,44.7-1.62,37.76-3.86,89.91-6.33,147.5-.51,11.83-1,23.42-1.5,34.52v.26h-.26l-124.12-5.48-36.66-1.67-9.87-.47-2.56-.14-.86-.06.87,0,2.55.08,9.88.39,36.66,1.51,124.13,5.31-.27.24c.49-11.1,1-22.7,1.5-34.52,2.53-57.59,4.82-109.73,6.48-147.49.86-18.87,1.55-34.14,2-44.7.25-5.27.44-9.37.57-12.16.07-1.38.13-2.43.17-3.16S243.44,58.55,243.44,58.55Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Glasses--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,205.47c.53.42,88.28-30.91,88.28-30.91l-2.7-8.07-86.14,23-4.71,7.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.34,244.22c-.76.26-3.57.2-3-3.39s27.69-46.91,30.76-50.92a41,41,0,0,1,13.22-11.2c6.21-3.47,25-11.14,25-11.14l2.57,7.71s-18.57,5.21-27,10.84-10.81,10-18.2,23-11.57,28.57-15.27,32.4A8.63,8.63,0,0,1,48.34,244.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.89,165.31c-3.94-.11-17-.88-30.27.88-12,1.59-33.84,8.39-53.71,20.81l-8.83,5.86a1.67,1.67,0,0,0-.74,2l3.94,11.78a1.67,1.67,0,0,0,1.27,1.11,8.93,8.93,0,0,1,6,4.67c2.67,4.8,12.81,21.31,22,24.28s26.86-1.51,34.85-4.19,24.94-9.4,29-19.64,4.45-22.81,4.45-29.21,1.37-9,6.11-10.57l-3-8.95A72.75,72.75,0,0,1,113.89,165.31Zm1.33,15.78c3.49,15.82,1.59,24.33-.87,29.53-3.17,6.71-7.69,12.31-26.49,18.53-19.42,6.43-31.07,4.81-35.46,2.62S40.07,217.4,35.67,206.18s.11-15.28,5.66-19.74c4-3.22,14.2-7.34,18.37-8.95,1.15-.45,2.31-.8,3.47-1.2,6.32-2.13,16.71-5.06,22.06-5.82S111.74,165.26,115.22,181.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.22,181.09s-.07-.2-.18-.59a14.21,14.21,0,0,0-4.49-7.17,18.74,18.74,0,0,0-10-3.66,53.56,53.56,0,0,0-14.29.84,123,123,0,0,0-16.93,4.07c-3,.88-6.08,1.91-9.23,3s-6.29,2.51-9.49,4c-1.6.73-3.21,1.51-4.79,2.36a28,28,0,0,0-4.57,2.91,33,33,0,0,0-4.09,3.75,11.11,11.11,0,0,0-2.65,4.85,13.44,13.44,0,0,0-.06,5.65,28.22,28.22,0,0,0,1.7,5.58,91.71,91.71,0,0,0,5.23,10.81,70.46,70.46,0,0,0,6.68,10,18.07,18.07,0,0,0,4.21,3.95A17.28,17.28,0,0,0,57.72,233a45.28,45.28,0,0,0,11.21.13,77.06,77.06,0,0,0,10.63-1.87c3.41-.83,6.7-1.82,9.86-2.91a92,92,0,0,0,9-3.56,45.55,45.55,0,0,0,7.82-4.48,23.44,23.44,0,0,0,5.77-5.92,29.64,29.64,0,0,0,3.32-6.77,30.12,30.12,0,0,0,1.4-6.6,51,51,0,0,0-.1-10.82c-.31-3-.71-5.24-1-6.79-.14-.76-.25-1.34-.33-1.75s-.1-.6-.1-.6.06.19.15.59l.39,1.74c.31,1.54.75,3.82,1.09,6.79a50.87,50.87,0,0,1,.19,10.88,30.73,30.73,0,0,1-1.37,6.66,25.27,25.27,0,0,1-1.41,3.45,27.24,27.24,0,0,1-1.93,3.42,23.63,23.63,0,0,1-5.83,6,45.07,45.07,0,0,1-7.88,4.55,88.83,88.83,0,0,1-9.05,3.6c-3.16,1.1-6.47,2.11-9.9,2.95A77.4,77.4,0,0,1,69,233.66a45.86,45.86,0,0,1-11.34-.13A17.85,17.85,0,0,1,52,231.84a18.35,18.35,0,0,1-4.36-4.07,70.9,70.9,0,0,1-6.73-10,89.08,89.08,0,0,1-5.26-10.88,28.62,28.62,0,0,1-1.73-5.68A14,14,0,0,1,34,195.3a11.41,11.41,0,0,1,1.07-2.72,15.21,15.21,0,0,1,1.7-2.34,34.32,34.32,0,0,1,4.15-3.79,29.56,29.56,0,0,1,4.66-3c1.6-.85,3.21-1.63,4.82-2.36q4.83-2.19,9.53-4c3.17-1.1,6.25-2.12,9.26-3a124.43,124.43,0,0,1,17-4,53.89,53.89,0,0,1,14.38-.76,18.91,18.91,0,0,1,10.1,3.79,13,13,0,0,1,3.9,5.61,11,11,0,0,1,.51,1.71C115.19,180.88,115.22,181.09,115.22,181.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.16,179c-1.19.46-22.41,8.7-22.55,16.87s7.69,23.58,12.13,28.81,17.72,5.39,24.33,3.95,9.38-55.11,9.38-55.11S75.22,172.87,59.16,179Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.43,170.87a11.23,11.23,0,0,1-1.52.75l-4.19,1.91a139.15,139.15,0,0,0-13.54,6.87,43.91,43.91,0,0,0-6.71,4.91,36.33,36.33,0,0,0-4.54,5c-1.14,1.57-2,2.89-2.6,3.79a10.4,10.4,0,0,1-1,1.39,10.06,10.06,0,0,1,.79-1.49c.55-.95,1.37-2.29,2.48-3.9A33.56,33.56,0,0,1,80.15,185a41.88,41.88,0,0,1,6.76-5,116.26,116.26,0,0,1,13.66-6.77c1.78-.78,3.25-1.35,4.27-1.75A9.52,9.52,0,0,1,106.43,170.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.14,175.38a28.7,28.7,0,0,1-3,1.44c-1.9.84-4.51,2-7.38,3.34s-5.44,2.6-7.3,3.51a25.93,25.93,0,0,1-3.06,1.41,19.41,19.41,0,0,1,2.89-1.74c1.82-1,4.38-2.31,7.25-3.65s5.52-2.46,7.46-3.21A18.26,18.26,0,0,1,112.14,175.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.14,142.21c-.18.66-89.13,28.41-89.13,28.41l-2.69-8.07L212,129.13l8.19,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.34,183c.77-.26,3-2,.35-4.5s-50.34-20.83-55.21-22.19a41.12,41.12,0,0,0-17.29-1c-7.05,1-26.65,6.12-26.65,6.12l2.58,7.71s18-7,28.13-7.62S177.9,163,191.64,169s26.43,15.86,31.69,16.7A8.62,8.62,0,0,0,231.34,183Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,165.09l3,8.95c4.75-1.59,7.41-.34,11.25,4.77s11.74,14.91,21.13,20.66,27,.93,35-1.74,24.82-9.73,30.36-17.62,3.7-27.18,3-32.62a8.87,8.87,0,0,1,2-7.33,1.71,1.71,0,0,0,.35-1.66L224,126.72a1.69,1.69,0,0,0-1.78-1.13l-10.58.63c-23.34,2-44.88,9.75-55.42,15.69-11.65,6.56-21.63,15.05-24.72,17.5A72,72,0,0,1,122,165.09Zm35.54-18.79c4.72-2.62,14.78-6.52,21.12-8.62,1.16-.38,2.31-.8,3.49-1.13,4.3-1.22,14.92-4.06,20.06-3.9,7.11.23,13.16.76,16.4,12.37s4.21,26.11,2,30.5-10.52,12.69-29.9,19.24C172,201.1,165,199.34,158.4,195.89c-5.09-2.68-11.73-8.33-18.46-23.07S152.76,148.93,157.52,146.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.52,146.3s-.17.12-.52.32l-1.57.86c-1.37.77-3.4,1.89-5.86,3.57a32,32,0,0,0-7.9,7.32,16.8,16.8,0,0,0-1.66,2.8,13,13,0,0,0-.28,10.65,76.09,76.09,0,0,0,3.71,7.47,59.68,59.68,0,0,0,5,7.55,35.16,35.16,0,0,0,6.83,6.79,27.5,27.5,0,0,0,4.33,2.58,25,25,0,0,0,4.83,1.81,28,28,0,0,0,10.67.41A70.25,70.25,0,0,0,186,196a97.83,97.83,0,0,0,21.8-9.15,56.18,56.18,0,0,0,5-3.37,34.85,34.85,0,0,0,4.46-3.92,15.65,15.65,0,0,0,3.32-4.71,19.48,19.48,0,0,0,.87-5.64,70.64,70.64,0,0,0-.6-11.23,93.24,93.24,0,0,0-1.95-10.62c-.84-3.4-1.85-6.74-3.8-9.42a10.8,10.8,0,0,0-3.55-3.22,13.27,13.27,0,0,0-4.46-1.45,31.88,31.88,0,0,0-9-.11c-2.88.39-5.61,1-8.21,1.57s-5.05,1.25-7.36,1.89-4.44,1.41-6.44,2.1c-4,1.39-7.41,2.71-10.17,3.83s-4.88,2.06-6.3,2.73l-1.6.79-.55.26L158,146c.35-.2.88-.48,1.58-.83,1.41-.71,3.52-1.67,6.27-2.83s6.15-2.49,10.15-3.92c2-.7,4.15-1.42,6.45-2.14s4.77-1.31,7.37-1.93,5.34-1.21,8.23-1.6a32.38,32.38,0,0,1,9.11.07,13.86,13.86,0,0,1,4.6,1.49,11.28,11.28,0,0,1,3.71,3.34c2,2.76,3,6.16,3.9,9.57a96.56,96.56,0,0,1,2,10.68A70.27,70.27,0,0,1,222,169.2a19.65,19.65,0,0,1-.9,5.8,16,16,0,0,1-3.42,4.89,36.66,36.66,0,0,1-4.53,4,55.07,55.07,0,0,1-5.06,3.39,97.36,97.36,0,0,1-21.91,9.2,70.81,70.81,0,0,1-11.06,2.46,28.39,28.39,0,0,1-10.85-.43,25.72,25.72,0,0,1-4.92-1.86A28,28,0,0,1,155,194a35.46,35.46,0,0,1-6.9-6.89,60,60,0,0,1-5-7.62,74.7,74.7,0,0,1-3.7-7.54,13.35,13.35,0,0,1-.77-7.56,13.59,13.59,0,0,1,1.11-3.35,16.59,16.59,0,0,1,1.71-2.84,26,26,0,0,1,4.05-4.32,40.63,40.63,0,0,1,4-3,67.18,67.18,0,0,1,5.92-3.49l1.59-.82C157.33,146.38,157.52,146.3,157.52,146.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.82,159.37a9,9,0,0,1,1.61-.51c1-.28,2.57-.71,4.47-1.16a114,114,0,0,1,15-2.81,41.79,41.79,0,0,1,8.42-.08,33.22,33.22,0,0,1,6.72,1.43c1.85.61,3.32,1.2,4.33,1.62a9,9,0,0,1,1.53.72,12,12,0,0,1-1.61-.53c-1-.37-2.5-.89-4.36-1.46a35.09,35.09,0,0,0-6.66-1.3,43.14,43.14,0,0,0-8.31.12,138,138,0,0,0-15,2.65l-4.5,1A12,12,0,0,1,140.82,159.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,166.4a20.74,20.74,0,0,1,3.2-1c2-.56,4.79-1.26,7.89-1.92s5.94-1.14,8-1.44a19.23,19.23,0,0,1,3.35-.35,24.92,24.92,0,0,1-3.28.71c-2,.39-4.85.93-8,1.59s-5.88,1.3-7.91,1.77A24.63,24.63,0,0,1,139,166.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.91,146.25c-4.21,1.23-16.34,7.35-20,13.19-2.06,3.28-3.1,8.89-.37,12.62s8.91,14.39,16.83,19.43,17.76,4.42,21.93,2.73-3.4-52.11-6.59-51.93S162.91,146.25,162.91,146.25Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.71,385.77a7.33,7.33,0,0,1,.51,3.21,10.54,10.54,0,0,1,1.46-3.63c.26-.42.68-.86,1.15-.74s.63.72.65,1.21a7.83,7.83,0,0,1-.89,3.91,8.68,8.68,0,0,1,3.31-2.57.78.78,0,0,1,.71-.05c.25.15.26.51.22.8a6.7,6.7,0,0,1-4.06,5.16l-.7.1A6.24,6.24,0,0,1,91.6,386c.11-.58.44-1.26,1-1.27S93.51,385.28,93.71,385.77Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4,417.11a20.22,20.22,0,0,0-6.65-2.68,27.38,27.38,0,0,0,.19-14.7,14.08,14.08,0,0,0-2.49-5.29,7.2,7.2,0,0,0-5-2.79,7,7,0,0,0-5.55,2.57l-2.46,5.68a23.33,23.33,0,0,0-.29,2.5,30.09,30.09,0,0,0,3.58,15.88c-2.55,2.82-5.32,7.68-4.49,13.31H115.4C115.91,426.19,113.85,420.33,109.4,417.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.44,420.09a1.61,1.61,0,0,1,.22-.32,10.76,10.76,0,0,1,.73-.84,13.47,13.47,0,0,1,3.23-2.47,15.27,15.27,0,0,1,5.75-1.83,14.5,14.5,0,0,1,7.31,1,14.67,14.67,0,0,1,5.76,4.61,15.4,15.4,0,0,1,2.61,5.44,13.19,13.19,0,0,1,.42,4.05,9.3,9.3,0,0,1-.11,1.1,1.22,1.22,0,0,1-.08.38,17.75,17.75,0,0,0-.53-5.45,15.31,15.31,0,0,0-2.64-5.27A13.71,13.71,0,0,0,99.41,415a15.49,15.49,0,0,0-5.64,1.71A18,18,0,0,0,89.44,420.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,404.48a7,7,0,0,1-.05-1.93,16.62,16.62,0,0,1,.78-4.61,9.56,9.56,0,0,1,2.5-4,4,4,0,0,1,1.64-1c0,.06-.61.42-1.43,1.26a10.52,10.52,0,0,0-2.29,3.88,21.07,21.07,0,0,0-.89,4.5A10.68,10.68,0,0,1,87,404.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.86,427.89a25.71,25.71,0,0,1,2.73-2.79,26.41,26.41,0,0,1,2.81-2.69,12.78,12.78,0,0,1-2.5,3A13,13,0,0,1,103.86,427.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.61,426.19a10.37,10.37,0,0,1,.48-2.89,9.84,9.84,0,0,1,.9-2.79,19,19,0,0,1-1.38,5.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,423a11.52,11.52,0,0,1,2.55,5.62,20.36,20.36,0,0,1-1.3-2.8A19.57,19.57,0,0,1,92,423Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.32,409.34a14.46,14.46,0,0,1,2-3,14,14,0,0,1,2.33-2.7,15.42,15.42,0,0,1-2,3A14.66,14.66,0,0,1,101.32,409.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.26,400.22a21.15,21.15,0,0,1,2.23-3.65,21.55,21.55,0,0,1,2.6-3.4,20.73,20.73,0,0,1-2.23,3.65A21,21,0,0,1,99.26,400.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,402.61a11.56,11.56,0,0,1,.41,3.09,11.29,11.29,0,0,1,0,3.12,10.88,10.88,0,0,1-.42-3.09A11,11,0,0,1,96,402.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.88,406.76A19.57,19.57,0,0,1,87,408.87a19.65,19.65,0,0,1,3.77,2.71,32.56,32.56,0,0,1-4-2.33A34.2,34.2,0,0,1,82.88,406.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.38,414.61a10.21,10.21,0,0,1,4.72-1.17c1.7-.08,3.6.09,4.75,1.34v.06a17.65,17.65,0,0,0-12,3.74A4.73,4.73,0,0,1,93.38,414.61Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M107.23,357.36a5.68,5.68,0,0,1,2.56-.1,8.53,8.53,0,0,1-2.71-1.48c-.3-.25-.6-.62-.47-1s.63-.42,1-.39a6.19,6.19,0,0,1,3,1.06,6.9,6.9,0,0,1-1.69-2.82.63.63,0,0,1,0-.57c.14-.18.42-.15.64-.09a5.28,5.28,0,0,1,3.65,3.66l0,.56a4.92,4.92,0,0,1-6,2.82c-.44-.14-.93-.46-.89-.92S106.83,357.46,107.23,357.36Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,320.1a5.79,5.79,0,0,1-.12,2.55,8.34,8.34,0,0,1,1.7-2.57c.27-.27.67-.55,1-.38s.37.65.31,1a6.31,6.31,0,0,1-1.31,2.88,6.74,6.74,0,0,1,3-1.45.61.61,0,0,1,.56.07c.17.16.11.43,0,.65a5.27,5.27,0,0,1-4,3.33l-.55,0a4.91,4.91,0,0,1-2.31-6.23c.18-.43.54-.9,1-.81S166,319.69,166,320.1Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.09,396.33c.44,0,.84.06,1.25.1.76-8.33-1.77-16.78.78-24.74l-.34.43a18.88,18.88,0,0,1-9.14-.82,11.43,11.43,0,0,1-6.61-6.12,8.27,8.27,0,0,1,1.41-8.66c2.88-3,8-2.85,11.58-.78s5.93,5.37,8.23,8.68a15,15,0,0,1,4-2.29c-4-5.53-7.9-11.34-9.17-18-1.39-7.31,1.34-16,8.13-19,5.78-2.6,13-.25,17.1,4.6a14.66,14.66,0,0,1,.87,1.2l-.13-.4a10.5,10.5,0,0,1,5.49-5.79,9,9,0,0,1,7.89.38,7.8,7.8,0,0,1,3.88,6.77,8.71,8.71,0,0,1-5,7.21,13.57,13.57,0,0,1-8.65.8,26.28,26.28,0,0,1-.05,7.77c-.9,5.81-3.5,11.22-6.58,16.26a14.3,14.3,0,0,1,2.37,1.95c5.24,5.49,5.58,14.29,2.83,21.36S145,399.47,139.86,405h0a33.52,33.52,0,0,1,4,12.43,11.33,11.33,0,0,1,10-6.4c2.26,0,4.78,1,5.47,3.15.62,1.89-.42,3.93-1.76,5.39a14.29,14.29,0,0,1-13.2,3.87l-.05-1.38a60.06,60.06,0,0,1-.23,9.5H110.76S101.87,395.47,125.09,396.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.63,
    y: 431.59,
    width: 78.71,
    height: 13.95,
    transform: "translate(223.96 877.14) rotate(180)",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.46 442.78 135.88 484.46 88.97 484.46 78.5 442.78 145.46 442.78",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.67,445.56c0,.16,17.75.28,39.65.28s39.65-.12,39.65-.28-17.75-.27-39.65-.27S72.67,445.41,72.67,445.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.92,397.7a2.61,2.61,0,0,1,.46-.26,9.19,9.19,0,0,1,1.38-.59,13.33,13.33,0,0,1,5.48-.63,16.65,16.65,0,0,1,7.7,2.69,20.64,20.64,0,0,1,6.62,7.49,30.52,30.52,0,0,1,3.17,9.51,50.53,50.53,0,0,1,.54,8.17c0,2.32-.09,4.2-.14,5.5,0,.61,0,1.1-.06,1.49a2.73,2.73,0,0,1,0,.52,1.86,1.86,0,0,1,0-.52c0-.39,0-.88,0-1.49,0-1.36,0-3.22,0-5.5a54,54,0,0,0-.62-8.1,30.61,30.61,0,0,0-3.16-9.37,20.6,20.6,0,0,0-6.45-7.36,16.68,16.68,0,0,0-7.51-2.72,14,14,0,0,0-5.4.48C119.58,397.39,119,397.75,118.92,397.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,380a1.1,1.1,0,0,1-.06-.4,10.81,10.81,0,0,1,0-1.13,18.59,18.59,0,0,1,.49-4.17,19.51,19.51,0,0,1,2.31-5.78,16,16,0,0,1,2.23-2.94,13.08,13.08,0,0,1,3.11-2.47,13.36,13.36,0,0,1,3.72-1.43,15.62,15.62,0,0,1,3.69-.28,18.42,18.42,0,0,1,6.06,1.44,20.65,20.65,0,0,1,3.68,2c.42.27.71.52.92.68s.3.25.29.26a13.62,13.62,0,0,1-1.3-.8,23.72,23.72,0,0,0-3.71-1.86,18.41,18.41,0,0,0-6-1.32,15.77,15.77,0,0,0-3.58.29,13.41,13.41,0,0,0-3.59,1.39,13,13,0,0,0-3,2.39,15.6,15.6,0,0,0-2.19,2.85,20.1,20.1,0,0,0-2.36,5.64,21,21,0,0,0-.62,4.1C126,379.49,126,380,126,380Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.88,344.84a14.2,14.2,0,0,1-.28-2.67c-.07-.82-.15-1.8-.33-2.87a14.38,14.38,0,0,0-1-3.38,33.93,33.93,0,0,0-3-5.65c-.91-1.38-1.59-2.14-1.54-2.18s.21.14.54.48a14.81,14.81,0,0,1,1.26,1.52,28,28,0,0,1,3.19,5.67,13.3,13.3,0,0,1,.94,3.48,26.32,26.32,0,0,1,.24,2.92A17.33,17.33,0,0,1,156.88,344.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.58,419.64a9.15,9.15,0,0,1,2.27,1.68,8.87,8.87,0,0,1,2,2,9.15,9.15,0,0,1-2.27-1.68A9.35,9.35,0,0,1,152.58,419.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.38,416.86a18.54,18.54,0,0,1,5.68-.56,9,9,0,0,1-2.82.5A9.24,9.24,0,0,1,155.38,416.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.26,412a15.36,15.36,0,0,1,1.58-2.18,15.79,15.79,0,0,1,1.59-2.18,8.47,8.47,0,0,1-3.17,4.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.53,409.7a12.12,12.12,0,0,1-.51,3.22,11.83,11.83,0,0,1-1,3.12,24.62,24.62,0,0,1,1.46-6.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,420.94c-.08-.09.45-.69,1.18-1.35s1.39-1.12,1.47-1-.45.7-1.18,1.36S147.13,421,147,420.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.48,418.77c-.09-.09.55-.9,1.42-1.81s1.66-1.59,1.75-1.5a12.09,12.09,0,0,1-3.17,3.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,408.09a6.48,6.48,0,0,1,1.06-2.17,6.56,6.56,0,0,1,1.45-1.93,13.53,13.53,0,0,1-2.51,4.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.6,399.39a8.93,8.93,0,0,1,.26,2.77,9,9,0,0,1-.18,2.78,8.58,8.58,0,0,1-.26-2.77A9.1,9.1,0,0,1,125.6,399.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.15,402.34a21,21,0,0,1,2.2,2.56,21.34,21.34,0,0,1,2.1,2.65,9.94,9.94,0,0,1-2.45-2.36A9.79,9.79,0,0,1,110.15,402.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.17,417.52a8.65,8.65,0,0,1,2.75.3,8.86,8.86,0,0,1,2.67.74,8.63,8.63,0,0,1-2.75-.3A8.75,8.75,0,0,1,108.17,417.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.2,422.81a7.89,7.89,0,0,1,1.06-3,8.31,8.31,0,0,1,1.82-2.66,21.12,21.12,0,0,1-1.42,2.86A22.4,22.4,0,0,1,124.2,422.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.85,415.52a6,6,0,0,1-.27-2.24,5.89,5.89,0,0,1,.17-2.25,5.53,5.53,0,0,1,.27,2.24A5.66,5.66,0,0,1,118.85,415.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.1,428.36A5,5,0,0,1,137,426a5.13,5.13,0,0,1,1.67-1.91,13.71,13.71,0,0,1-1.29,2.14A13,13,0,0,1,136.1,428.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.8,429.42a7.35,7.35,0,0,1-1.19-2.16,7.07,7.07,0,0,1-.79-2.34,7.19,7.19,0,0,1,1.19,2.16A7,7,0,0,1,117.8,429.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.25,395.57a11,11,0,0,1,3.05-.12,10.89,10.89,0,0,1,3,.32,10.12,10.12,0,0,1-3.05.12A10.53,10.53,0,0,1,146.25,395.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.88,384.22a16.13,16.13,0,0,1,2.93-2.35,16.33,16.33,0,0,1,3.18-2,16,16,0,0,1-2.92,2.34A15.7,15.7,0,0,1,152.88,384.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.2,369.63a17.87,17.87,0,0,1,2.38-1.58,20.44,20.44,0,0,1,2.38-1.58,6.34,6.34,0,0,1-2.13,1.95A6.44,6.44,0,0,1,152.2,369.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.76,364.47a14.62,14.62,0,0,1,.65-3.55,14.94,14.94,0,0,1,1.07-3.46,28.83,28.83,0,0,1-1.72,7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.34,360.8a7.68,7.68,0,0,1,1.44,2.14,7.45,7.45,0,0,1,1.06,2.35,7.68,7.68,0,0,1-1.44-2.14A7.45,7.45,0,0,1,132.34,360.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.63,385.41c.08-.1,1.5,1,3.36,2.13s3.47,1.94,3.41,2a11.4,11.4,0,0,1-3.64-1.67A11.53,11.53,0,0,1,121.63,385.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,390.94a15.94,15.94,0,0,1,4.5-2.77,8.34,8.34,0,0,1-2.14,1.57A7.85,7.85,0,0,1,139,390.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.9,379.17c-.09-.1,1-1.2,2.07-2.81s1.62-3.07,1.74-3a9.76,9.76,0,0,1-3.81,5.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.2,376.51a8.75,8.75,0,0,1-.09-2.85,9.31,9.31,0,0,1,.35-2.83,9.47,9.47,0,0,1,.09,2.85A9.31,9.31,0,0,1,136.2,376.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.05,388.15a10.09,10.09,0,0,1-.56-2.88,9.67,9.67,0,0,1-.11-2.94,19.88,19.88,0,0,1,.67,5.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.25,353.1a27.59,27.59,0,0,1,.92,3.25,24.87,24.87,0,0,1,.93,3.26,9.13,9.13,0,0,1-1.35-3.14A8.82,8.82,0,0,1,124.25,353.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.05,373.53a20.86,20.86,0,0,1,2.54-1.87,21,21,0,0,1,2.56-1.85,11.8,11.8,0,0,1-5.1,3.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.62,367.26a19.29,19.29,0,0,1,3.1-.63,18.92,18.92,0,0,1,3.12-.56,8.25,8.25,0,0,1-3,1A8.15,8.15,0,0,1,109.62,367.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.82,360.25a4.6,4.6,0,0,1,1.77.87c.92.59,1.6,1.14,1.54,1.25a4.61,4.61,0,0,1-1.78-.88C118.44,360.91,117.75,360.35,117.82,360.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.73,352.68a8.17,8.17,0,0,1,3.39,3.89,13.71,13.71,0,0,1-1.71-1.93A14.57,14.57,0,0,1,113.73,352.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.15,359.89a16.93,16.93,0,0,1,2.87.72,15.59,15.59,0,0,1,2.84.82,7.72,7.72,0,0,1-3-.4A7.37,7.37,0,0,1,108.15,359.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.78,350.19a41.67,41.67,0,0,1,2.52-3.84,43.81,43.81,0,0,1,2.55-3.8,16.44,16.44,0,0,1-2.18,4.05A17.12,17.12,0,0,1,146.78,350.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.3,341.35a12.33,12.33,0,0,1,.21-3.29,12.53,12.53,0,0,1,.65-3.24,12.33,12.33,0,0,1-.21,3.29A12.53,12.53,0,0,1,144.3,341.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.72,342.73c.13,0,.49,1.67,1.34,3.62s1.82,3.37,1.72,3.45a8.69,8.69,0,0,1-2.13-3.28A8.91,8.91,0,0,1,135.72,342.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.63,344.86c.11-.08,1.36,1.4,3.1,3s3.28,2.79,3.2,2.9a18,18,0,0,1-6.3-5.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.54,326.55c.12,0,.51,1.84,1.21,4.07s1.41,4,1.29,4a13,13,0,0,1-1.72-3.91A12.81,12.81,0,0,1,129.54,326.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.15,320.53a24.48,24.48,0,0,1,.4,6.54,24.48,24.48,0,0,1-.4-6.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.13,336a14.25,14.25,0,0,1,2.5.18,13.05,13.05,0,0,1,2.49.23,5.09,5.09,0,0,1-2.53.21A5,5,0,0,1,165.13,336Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.42,330a18.1,18.1,0,0,1,3.43-2.08,19,19,0,0,1,3.64-1.68,17.79,17.79,0,0,1-3.43,2.07A18.82,18.82,0,0,1,164.42,330Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.94,330.18a11.31,11.31,0,0,1,.73-3.08,11.06,11.06,0,0,1,1.16-2.94,12.16,12.16,0,0,1-.74,3.08A11.68,11.68,0,0,1,157.94,330.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.78,405.06a10.37,10.37,0,0,0-4.43-8.14c-2.62-1.76-7.34-1.93-9.19-.62a14.25,14.25,0,0,1,8.06,2.79,22.59,22.59,0,0,1,5.56,6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150,364.47a9,9,0,0,0-6.33-4.93c-2.69-.49-6.5,1-7.51,2.69a12.34,12.34,0,0,1,7.36-.58,19.52,19.52,0,0,1,6.48,2.82"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156.83,340.34a7.12,7.12,0,0,0,.43-6.14,6,6,0,0,0-4.37-3.52c2.08,3,3.72,6.1,3.88,9.77"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M114.84,399.61s-.35.32-.9,1a18,18,0,0,0-2,3A32.29,32.29,0,0,0,109,414.92a52.06,52.06,0,0,0,.59,11.81c.23,1.51.46,2.72.62,3.55a7.34,7.34,0,0,1,.2,1.31,6.07,6.07,0,0,1-.39-1.27c-.21-.82-.49-2-.77-3.53a47.11,47.11,0,0,1-.73-11.91,30.21,30.21,0,0,1,3.07-11.52,15.1,15.1,0,0,1,2.17-2.91A3.55,3.55,0,0,1,114.84,399.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.33,431.59a.75.75,0,0,1-.24,0l-.7,0-2.7,0-9.93.07-32.76.07-32.37-.07.15-.16c0,4.3,0,7.78,0,10.22,0,1.19,0,2.12,0,2.78,0,.3,0,.54,0,.73a.64.64,0,0,1,0,.24.64.64,0,0,1,0-.24l0-.73c0-.66,0-1.59-.05-2.77,0-2.45-.06-5.93-.1-10.22v-.16h.16l32.37-.07,32.76.07,9.93.07,2.7,0,.7,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "272.38 483.53 416.94 483.53 403.48 443.91 292.7 449.66 272.38 483.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.3,450.47l84.48-3.15,30-168-27.11-11.67s-11.25,6.31-32.09,6.41c-20.45.1-20.09-6.85-20.09-6.85l-17.93,19.31s-22.07,62.79-22.4,64.06S299.3,450.47,299.3,450.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,271.93s41.61,8.6,42,15.53-17.8,49.9-18.15,51S404.46,401,404.46,401l24,82.54h-74.8S359,405.67,365,369.69s7.43-48,9.74-62.26c.92-5.71,5.57-25.3,8.46-37.26a26.55,26.55,0,0,0,.44-10.3l3.55,1.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.82,377.28c-.4.6-8,28.19-9.25,36.18-1.06,6.78-2.74,17.8,4.45,28s14.62,9,21.8,6.4,15-17.59,16.38-26.19-6.74-46.42-6.74-46.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.57,261.86l-9.26,13.07s-30.88,4-38,9.18-21.47,98.65-21.47,98.65l28.73,16-22.2,84.78h27.83s6.9-35.73,6.27-61.39,3.82-59,12-83.66,16-67.3,16-67.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M418.65,452.33l-49.77-27.68C371,436.06,377.7,447,387.5,453.22A43,43,0,0,0,421,458.5Q419.8,455.41,418.65,452.33Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.18,399.63c0,.09-1.18.28-2.94,1a15.22,15.22,0,0,0-5.89,4.48,15.38,15.38,0,0,0-3,6.76c-.33,1.89-.23,3.1-.33,3.11a2.49,2.49,0,0,1-.12-.85,11.54,11.54,0,0,1,.09-2.32,14.28,14.28,0,0,1,9.11-11.52,11.83,11.83,0,0,1,2.24-.63A2.44,2.44,0,0,1,271.18,399.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,438.45s7.9-2.5,10.74-5.71A23.67,23.67,0,0,0,293,421.61c.36-4.76,2.15-29.76,2.15-29.76l-20.82-1.37L261.49,415s-3.48,9,3.63,18.59C269.66,439.74,277,438.45,277,438.45Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,424.65a28,28,0,0,1,.28-2.88,32.57,32.57,0,0,0-.1-6.92,33.34,33.34,0,0,0-1.59-6.75c-.59-1.68-1.06-2.68-1-2.72s.18.22.43.66a17.83,17.83,0,0,1,.9,1.93,27,27,0,0,1,1.72,13.85,19.7,19.7,0,0,1-.4,2.09A2.4,2.4,0,0,1,297,424.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.22,425.13a6.17,6.17,0,0,1,0,1.2,11.82,11.82,0,0,1-.12,1.4c-.08.54-.14,1.16-.3,1.83a26.51,26.51,0,0,1-1.36,4.66,30.81,30.81,0,0,1-2.72,5.27,31.26,31.26,0,0,1-3.75,4.6,27,27,0,0,1-3.73,3.1,15.34,15.34,0,0,1-1.57,1,9.24,9.24,0,0,1-1.23.67,5.24,5.24,0,0,1-1.1.48c0-.09,1.49-.83,3.69-2.44a31.27,31.27,0,0,0,3.6-3.14,32.82,32.82,0,0,0,3.65-4.56A33.53,33.53,0,0,0,294,434a30.25,30.25,0,0,0,1.44-4.55C296.05,426.83,296.11,425.12,296.22,425.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.57,263.78a13.47,13.47,0,0,0-8.76,5.15l46.51,66,58.07-6.65-.94-59.38s-3.94-5.72-7.76-5.08c-1.53.26-50.65,7.93-55,19.95,0,0,.51-6.14-3.59-9.21S201.57,263.78,201.57,263.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.57,263.78l.68.19,2,.62c1.74.55,4.33,1.37,7.65,2.49s7.4,2.52,12.08,4.36c1.17.47,2.37,1,3.6,1.53a11.61,11.61,0,0,1,3.53,2.25c2.06,2.13,2.89,5.34,2.77,8.55l-.34-.08a12.35,12.35,0,0,1,4.81-5.24,42.69,42.69,0,0,1,6.74-3.58,117.15,117.15,0,0,1,15.78-5.35c5.64-1.55,11.61-2.92,17.86-4.16,3.12-.62,6.32-1.21,9.57-1.74a4.9,4.9,0,0,1,2.57.17,8.69,8.69,0,0,1,2.25,1.25,17.52,17.52,0,0,1,3.54,3.7l.05.06v.08c.24,15.31.51,32,.79,49.33q.09,5.07.16,10.05v.23l-.24,0-58.07,6.63h-.14l-.08-.11L192.74,269l0-.05,0-.05a11.37,11.37,0,0,1,3.33-3.1,15.12,15.12,0,0,1,3-1.42,12.6,12.6,0,0,1,1.89-.52,3.67,3.67,0,0,1,.66-.06,6.41,6.41,0,0,0-.65.11,12.5,12.5,0,0,0-1.87.56,15,15,0,0,0-2.9,1.45,11.25,11.25,0,0,0-3.26,3.08v-.1l46.63,65.9-.22-.1L297.36,328l-.23.27q-.08-5-.16-10c-.27-17.33-.53-34-.77-49.34l.05.14a17.24,17.24,0,0,0-3.44-3.59,8.13,8.13,0,0,0-2.11-1.18,4.38,4.38,0,0,0-2.33-.15c-3.25.52-6.44,1.11-9.56,1.72-6.24,1.23-12.21,2.59-17.84,4.12a118.79,118.79,0,0,0-15.73,5.29,42.47,42.47,0,0,0-6.7,3.53,12,12,0,0,0-4.68,5.05l-.38.93,0-1c.13-3.11-.67-6.27-2.64-8.3a11.21,11.21,0,0,0-3.44-2.2c-1.21-.57-2.41-1.07-3.57-1.55-4.66-1.86-8.73-3.28-12-4.43l-7.62-2.58-2-.66C201.79,263.87,201.57,263.78,201.57,263.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.11,344.12l-43.55-74a1.9,1.9,0,0,1,.2-2.22h0a1.92,1.92,0,0,1,2.14-.51l34.33,13.68a4.5,4.5,0,0,1,1.72,1.2h0a4.61,4.61,0,0,1,1.07,4.07l-.51,2.29,12,3.07.26-.67a8.82,8.82,0,0,1,5.56-5.21l55.31-17.62a5.09,5.09,0,0,1,6.08,2.51L344,346.43,342.67,350,280.23,364.8h-11Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.11,344.12l.69.34,2,1,7.7,4,28.84,15.15-.08,0h10.94l62.43-14.85-.17.15c.39-1.1.83-2.34,1.28-3.58v.18l-20.3-39.16q-5.32-10.31-10.89-21L307,275.53l-1.41-2.73-.71-1.37a8.18,8.18,0,0,0-.75-1.3,4.85,4.85,0,0,0-5.24-1.73l-32.67,10.4-15.71,5c-2.57.83-5.17,1.61-7.65,2.46a8.79,8.79,0,0,0-5.05,5.51l-.06.21-.23-.06-12-3.07-.23-.06.05-.23.41-1.83a5.09,5.09,0,0,0,.19-1.76,4.35,4.35,0,0,0-1.58-3,5.15,5.15,0,0,0-1.55-.84l-1.69-.67-3.37-1.35-13.1-5.23-12.5-5-3-1.2a1.72,1.72,0,0,0-2.42.83,1.74,1.74,0,0,0,0,1.38l.78,1.35,1.58,2.69c8.37,14.25,15.73,26.8,21.82,37.19l14.22,24.29,3.76,6.48,1,1.68c.21.37.31.57.31.57s-.12-.18-.34-.55-.56-.92-1-1.64L225,335.5c-3.33-5.63-8.19-13.85-14.33-24.21l-21.93-37.17-1.59-2.69c-.27-.46-.53-.89-.81-1.38a2.12,2.12,0,0,1,1.2-2.91,2.27,2.27,0,0,1,1.72.12l3,1.21,12.51,5,13.11,5.22,3.36,1.34,1.7.67a5.57,5.57,0,0,1,1.67.91,4.83,4.83,0,0,1,1.76,3.35,5.53,5.53,0,0,1-.2,1.91l-.4,1.83-.18-.29,12,3.06-.29.15a9.3,9.3,0,0,1,5.32-5.79c2.55-.88,5.1-1.65,7.68-2.48l15.72-5,32.67-10.41a5.38,5.38,0,0,1,5.81,1.92,8.33,8.33,0,0,1,.79,1.37l.71,1.37,1.42,2.73q2.81,5.44,5.59,10.81l10.89,21,20.26,39.18,0,.09,0,.09-1.28,3.58,0,.12-.13,0L280.27,365h0l-11,0h0l0,0-28.8-15.3-7.65-4.09-2-1.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "260.79 356 232.25 342.35 192.84 277.41 227.65 290.91 226.92 292.78 197.6 281.4 233.65 340.8 261.65 354.19 260.79 356"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M283.85,360l-35.91-64.82,52.92-17L335.35,345Zm-33-63.66,33.95,61.29,47.64-13.94-32.6-63.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M277.46,364.06c-.12.07-9.13-16-20.12-36s-19.78-36.17-19.66-36.24,9.13,16,20.12,36S277.59,364,277.46,364.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.51,288.61a5.57,5.57,0,0,1,.46.74l1.24,2.15c1.07,1.88,2.58,4.61,4.44,8,3.71,6.76,8.75,16.16,14.26,26.57L260,352.72l4.29,8.07c.48.92.86,1.66,1.15,2.2a4.65,4.65,0,0,1,.37.79,5.57,5.57,0,0,1-.46-.74l-1.24-2.15c-1.07-1.88-2.58-4.61-4.44-8-3.71-6.77-8.75-16.17-14.26-26.58l-14.12-26.65L227,291.6c-.48-.92-.86-1.66-1.15-2.2A4.65,4.65,0,0,1,225.51,288.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.26,289.81a8.77,8.77,0,0,1,.44-3,9.07,9.07,0,0,1,.94-2.89,8.82,8.82,0,0,1-.44,3A9.07,9.07,0,0,1,232.26,289.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "238.89 309.82 260.1 349.11 267.48 350.17 246.39 311.18 238.89 309.82"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "231.35 299.33 243.1 301.68 245.68 305.96 233.64 303.58 231.54 299.97"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "273.26 299.27 271.19 294.48 284.34 289.81 286.63 294.54 273.26 299.27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "272.38 323.58 265.09 309.82 302.32 296.09 308.89 309.82 272.38 323.58"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M392.08,103.36a12.9,12.9,0,0,1,11-3.34c1.59.28,3.31.85,4.74.09a10.46,10.46,0,0,0,2.38-2.49,6.53,6.53,0,0,1,9.41.2,7.7,7.7,0,0,0,1.77,1.91c3,1.79,6.77-3.9,9.8-2.08a7.42,7.42,0,0,0-3.61,2.56,3.37,3.37,0,0,0,.18,4.15c2.8,2.71,7.88-2.8,11-.52,1.69,1.24,1.79,4.23,3.8,4.82a7,7,0,0,0,2.42-.06,5.39,5.39,0,0,1,5.49,4.9c.12,2.33-1.18,5.1.48,6.73,1,1,2.67.94,4.11.79a14.1,14.1,0,0,1-1.82,6.07,8.43,8.43,0,0,1,2.28,11.47,18,18,0,0,1,4.61,5.21c1.05,2.08,1.19,4.8-.27,6.62a5.27,5.27,0,0,0-.95,1.27,3.06,3.06,0,0,0-.09,1.7c.34,2.19,1.19,4.34,1,6.55s-1.93,4.55-4.13,4.26c-.51-.07-1.07-.27-1.51,0a1.47,1.47,0,0,0-.58,1,14.86,14.86,0,0,0,.08,4.75,6.38,6.38,0,0,1-.93,4.57c-1,1.25-3.19,1.59-4.12.3l1.53,7.48c.3,1.48.52,3.27-.6,4.29-1.47,1.34-3.94.11-4.91-1.62s-1.17-3.82-2.19-5.52a12.28,12.28,0,0,1-1.24-2.08c-.21-.61-.26-1.32-.73-1.75-.95-.87-2.55.44-2.48,1.73s1.05,2.3,1.81,3.34,1.34,2.49.63,3.57c-.34.52-.93.84-1.26,1.37-1.14,1.82,1.52,3.78,1.74,5.92.17,1.58-1.05,2.94-2.23,4-1.44,1.3-4.14,2.27-4.92.5a18.77,18.77,0,0,1-.33-2,4.9,4.9,0,0,0-1.44-1.84,10.12,10.12,0,0,1-2.74-5.1c1.54,2.1,3.13,4.85,1.85,7.11a10.84,10.84,0,0,1-2.26,2.33c-1.55,1.46-2.56,3.41-4.09,4.89s-4,2.43-5.79,1.3a4.79,4.79,0,0,1-8.25,4.37,4.18,4.18,0,0,0-1.25-1.23,3.48,3.48,0,0,0-1.87,0,10.39,10.39,0,0,1-9.83-4.51l1.93-.58c-3.71-.67-7.58-1.4-10.58-3.68s-4.81-6.61-3-9.94c.77-1.44,2.19-2.89,1.66-4.43-.37-1.07-1.53-1.6-2.57-2l-13.1-5.34c-2.12-.86-4.35-1.81-5.7-3.66s-1.33-4.89.64-6.06a12.32,12.32,0,0,0-4.38-5.23c-2.15-1.43-4.71-2.16-6.92-3.5s-4.18-3.65-3.89-6.22,3.94-4.4,5.63-2.43c-.17-3.91-7.08-4.48-7.48-8.37-.33-3.15,3.75-4.58,5.93-6.89-.37-1.11-1.44-1.86-1.84-3-.85-2.3,1.6-4.44,3.86-5.38s5-1.88,5.66-4.24-1.29-5.29.11-7.36a2.78,2.78,0,0,1,3.69-.73c2-4.39,10.26-.61,12.92-4.64a1.75,1.75,0,0,0,.34-1.07,1.91,1.91,0,0,0-.39-.9c-.91-1.27-2.38-2-3.57-3s-2.15-2.67-1.52-4.11,3.4-1.25,3.29.32a3.44,3.44,0,0,1,5.2,1.57c1.14-1.25,3.26-1.13,4.67-.2a10.82,10.82,0,0,1,3.14,4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.89,153.85c-1.23-6.47-5.84-11.8-11-15.92a16.81,16.81,0,0,0-7.23-3.84c-2.72-.5-5.85.38-7.29,2.74l.26,4.61c-.77,7.3,4.72,13.59,7.24,20.48,1.1,3,2,6.59,4.86,7.93a6.86,6.86,0,0,0,4.91.07C408.93,167.93,412.12,160.32,410.89,153.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.71,187.68a14.72,14.72,0,0,0-1.12-18.84c2.73-3.35,1.81-8.57-.89-11.94s-6.74-5.33-10.64-7.19c-2.05-9.91-13.08-17-22.94-14.7-5.05-7.58-15.95-8.88-24.73-6.42a23.33,23.33,0,0,1-6.51,1.36,40.08,40.08,0,0,1-4.84-.72c-8.88-1.29-17.78,4.88-21.33,13.13a16.39,16.39,0,0,1-1.93,3.83c-1.17,1.48-2.93,2.34-4.43,3.47a14.24,14.24,0,0,0-5.56,10.46c-.18,3.45.89,7.13-.6,10.25-.75,1.57-2.08,2.82-2.66,4.46-1.7,4.73,3.52,9.63,2.49,14.55-.21,1-.67,1.94-1,2.92a8.8,8.8,0,0,0,.47,6.14c.69,1.46,1.81,2.81,1.89,4.43a14.13,14.13,0,0,1-.76,3.58c-.63,2.94,5.61,14.35,8.13,16l76,1.45a14.21,14.21,0,0,0,11.11-12.11,5.17,5.17,0,0,1,.73-2.79,6.12,6.12,0,0,1,2.09-1.33c4.92-2.57,5.58-9.29,5.12-14.82a6.69,6.69,0,0,1,.07-2.32A8.41,8.41,0,0,1,410.71,187.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.05,187.58c.36-13.45-7.91-29-21.2-35.7-8.38-4.23-15-4.32-19.37-4.88a30.77,30.77,0,0,0-18,3.57c-4.2.94-19.69,14.84-20.64,30.08-1.06,16.93-1.68,37.65.33,50.28,4.05,25.4,23.52,28.62,23.52,28.62s-.88,20.13-.88,20.13L347,306l36.54-37.21Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.19,227.1a5.29,5.29,0,0,0-1.67-3.4,5.47,5.47,0,0,0-6.6-.74,7.34,7.34,0,0,0-3.16,6.72h0a6.68,6.68,0,0,0,4.61,3c.3,0,.6.07.9.08a6,6,0,0,0,4.11-1.38A5.33,5.33,0,0,0,348.19,227.1Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.55,203.36a3.25,3.25,0,0,0,3.15,3.28,3.11,3.11,0,0,0,3.35-2.94,3.24,3.24,0,0,0-3.14-3.28A3.12,3.12,0,0,0,315.55,203.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.6,190.39c.41.43,2.88-1.4,6.38-1.4s6.08,1.76,6.46,1.33c.18-.19-.23-.95-1.35-1.77a8.94,8.94,0,0,0-5.17-1.59,8.63,8.63,0,0,0-5.07,1.64C315.77,189.43,315.41,190.2,315.6,190.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.13,218.06c0-.2-2.16-.57-5.69-1-.9-.09-1.75-.27-1.9-.88a4.51,4.51,0,0,1,.6-2.65l2.64-6.82c3.67-9.71,6.33-17.69,5.94-17.84s-3.69,7.61-7.36,17.32c-.88,2.39-1.73,4.67-2.53,6.86a5.14,5.14,0,0,0-.46,3.51,2.24,2.24,0,0,0,1.47,1.31,6.48,6.48,0,0,0,1.52.21C333.91,218.25,336.12,218.26,336.13,218.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.73,259.55a64.69,64.69,0,0,0,34-9.09s-9,18.25-34.41,15.89Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.45,220.48c-.57,0-.58,3.77-3.83,6.48s-7.31,2.28-7.34,2.82c0,.23.91.73,2.62.78a9.41,9.41,0,0,0,6.12-2.14,8.23,8.23,0,0,0,3-5.43C347.13,221.4,346.71,220.46,346.45,220.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,177.25c.59.86,3.28.29,6.41.55s5.74,1.08,6.43.31c.31-.38,0-1.21-1.12-2.07a9.52,9.52,0,0,0-5.09-1.8,9.38,9.38,0,0,0-5.26,1.11C317.2,176.06,316.76,176.84,317,177.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.24,204.85A3.26,3.26,0,0,1,350,208a3.12,3.12,0,0,1-3.25-3.06,3.27,3.27,0,0,1,3.26-3.17A3.12,3.12,0,0,1,353.24,204.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.57,191.74c-.42.41-2.82-1.5-6.32-1.63s-6.14,1.54-6.5,1.1c-.18-.2.26-1,1.41-1.72a8.94,8.94,0,0,1,5.22-1.4,8.56,8.56,0,0,1,5,1.82C363.44,190.78,363.77,191.56,363.57,191.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.56,180c-.72.77-3.4-.16-6.64-.32s-6,.32-6.63-.54c-.26-.41.2-1.19,1.43-1.9a10.56,10.56,0,0,1,10.69.69C364.53,178.78,364.87,179.61,364.56,180Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.86,211.65c0-1.9,2.19-6.36,4.06-6.65,5-.78,14-.38,14.07,12.28.12,17.32-17.29,13.88-17.33,13.38S384.85,218.18,384.86,211.65Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.4,224.3c.07-.06.3.21.81.44a3.07,3.07,0,0,0,2.26,0c1.82-.69,3.34-3.6,3.4-6.72a9.84,9.84,0,0,0-.87-4.32,3.49,3.49,0,0,0-2.29-2.3,1.53,1.53,0,0,0-1.77.84c-.23.49-.12.83-.21.86s-.37-.28-.24-1a1.91,1.91,0,0,1,.67-1.09,2.28,2.28,0,0,1,1.67-.45,4.22,4.22,0,0,1,3.17,2.66,10.16,10.16,0,0,1,1.08,4.82c-.08,3.49-1.85,6.77-4.35,7.51a3.2,3.2,0,0,1-2.76-.44C390.43,224.72,390.34,224.33,390.4,224.3Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.92,180.89c3.5-2.19,5.74-5.17,5.52-9.29,2.32.69,4.68-2.29,6-4.3s3-3,2.91-5.44a2.8,2.8,0,0,1,.17-1.41c.35-.66,1.18-.88,1.89-1.1a11.61,11.61,0,0,0,7.65-8.06,24.63,24.63,0,0,0,11.86,2,9.39,9.39,0,0,0,15.88-.69,8.39,8.39,0,0,0,5.63,4.15,25,25,0,0,0,7.18.39,9.93,9.93,0,0,0,6.54,11.25c.61.19,1.32.38,1.61,1a2.53,2.53,0,0,1-.27,1.93,7.81,7.81,0,0,0,5.23,9.95,5.84,5.84,0,0,0,.53,9.14c.63.38,1.45.83,1.35,1.56a1.55,1.55,0,0,1-.38.74c-1.29,1.71-2.57,3.59-2.73,5.72s1.29,4.54,3.43,4.64a5.58,5.58,0,0,0-2.2,3.79c0,1.51,1.5,3,2.9,2.5.6-.23,9.22-1.93,9.6-2.44,4.9-6.65-1.26-14-1.74-22.25a53.68,53.68,0,0,0-7.49-23.4,39.1,39.1,0,0,0-6.14-8.35,52.53,52.53,0,0,0-9.52-7c-4.38-2.73-8.88-5.44-13.9-6.63-9.34-2.2-19,1.19-27.77,5.22a40.57,40.57,0,0,0-9.41,5.54,36.74,36.74,0,0,0-7.93,10.35c-3.09,5.51-5.66,11.45-6.27,17.73",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.53,174.83a6.49,6.49,0,0,1,.93-1.86c.37-.58.89-1.25,1.38-2.11a8,8,0,0,0,1-3.23,25.94,25.94,0,0,0-.07-4.28,18.78,18.78,0,0,1,.14-5.15,14.57,14.57,0,0,1,2.28-5.45,14,14,0,0,1,2.14-2.45,22.22,22.22,0,0,1,2.73-2,10.6,10.6,0,0,0,2.64-2.27,14.37,14.37,0,0,0,1.65-3.25,23.23,23.23,0,0,1,10.93-11.85,20.82,20.82,0,0,1,4.17-1.56,19.12,19.12,0,0,1,4.55-.51,23.06,23.06,0,0,1,2.34.19c.77.12,1.53.29,2.3.43a11.28,11.28,0,0,0,4.63,0c1.55-.31,3.07-.86,4.67-1.26a30.44,30.44,0,0,1,10-.9,26.41,26.41,0,0,1,5.08,1A17.1,17.1,0,0,1,374.7,134c.21.29.42.58.64.86l-.28-.11a20.07,20.07,0,0,1,23.24,14.9l-.13-.17a53.7,53.7,0,0,1,6.06,3.21,18.22,18.22,0,0,1,4.95,4.45,11.81,11.81,0,0,1,2.25,6,8.23,8.23,0,0,1-1.67,5.85v-.29a14.36,14.36,0,0,1,4,8.9,14.71,14.71,0,0,1-1.82,8.6,13.09,13.09,0,0,1-1.15,1.71,18,18,0,0,0-1.2,1.55,3.74,3.74,0,0,0-.62,1.7,10.71,10.71,0,0,0,.05,1.79,28.22,28.22,0,0,1-.2,6.58,13.76,13.76,0,0,1-1.71,5,8.46,8.46,0,0,1-2.7,2.8c-.89.59-1.69.82-2.13,1.14a4.06,4.06,0,0,0-.63.52,2,2,0,0,1,.6-.58c.43-.34,1.23-.59,2.09-1.19a8.33,8.33,0,0,0,2.6-2.79,13.61,13.61,0,0,0,1.64-4.94,28.93,28.93,0,0,0,.14-6.51,10.25,10.25,0,0,1-.06-1.85,4.05,4.05,0,0,1,.66-1.85,18.24,18.24,0,0,1,1.2-1.58A13.89,13.89,0,0,0,411.6,186a14.34,14.34,0,0,0,1.72-8.4,13.89,13.89,0,0,0-3.88-8.62l-.14-.14.12-.15a7.73,7.73,0,0,0,1.55-5.55,11.36,11.36,0,0,0-2.17-5.74,17.9,17.9,0,0,0-4.83-4.31,54.35,54.35,0,0,0-6-3.17l-.11-.05,0-.13a19.6,19.6,0,0,0-22.64-14.49l-.17,0-.11-.14c-.2-.28-.41-.55-.62-.83a16.6,16.6,0,0,0-8.44-5.59,25.83,25.83,0,0,0-5-.92,29.77,29.77,0,0,0-9.81.87c-1.57.39-3.11.95-4.71,1.26a12.26,12.26,0,0,1-2.42.24,14.57,14.57,0,0,1-2.39-.26c-.77-.14-1.53-.31-2.29-.43a21.71,21.71,0,0,0-2.27-.19,18.18,18.18,0,0,0-4.43.49,20.33,20.33,0,0,0-4.08,1.51A22.89,22.89,0,0,0,317.7,142.9a14.83,14.83,0,0,1-1.71,3.34,11.18,11.18,0,0,1-2.74,2.34,20.77,20.77,0,0,0-2.71,2,13.72,13.72,0,0,0-2.09,2.38,14.1,14.1,0,0,0-2.27,5.32,18.66,18.66,0,0,0-.19,5.07,24.1,24.1,0,0,1,0,4.32,8.28,8.28,0,0,1-1,3.29c-.52.87-1.05,1.52-1.43,2.09a9.91,9.91,0,0,0-.79,1.32C302.6,174.66,302.54,174.83,302.53,174.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,131.19s-.46-.26-1.3-.68a11.57,11.57,0,0,0-3.77-1.11,10.9,10.9,0,0,0-5.7.82A11.29,11.29,0,0,0,351,134.9a9.7,9.7,0,0,0-.87,2,2.18,2.18,0,0,0,.13,1.82l.42.59-.7-.2a7.21,7.21,0,0,0-5.36.63,7,7,0,0,0-2.94,3.2,7.42,7.42,0,0,0-.68,2.85c0,.69,0,1.07,0,1.08s0-.09-.08-.27a4.46,4.46,0,0,1-.09-.81,7.25,7.25,0,0,1,3.59-6.44,7.59,7.59,0,0,1,5.71-.73l-.28.39a2.59,2.59,0,0,1-.2-2.25,9.59,9.59,0,0,1,.91-2.08,11.54,11.54,0,0,1,5.45-4.86A11,11,0,0,1,362,129a10.66,10.66,0,0,1,3.82,1.29,7.79,7.79,0,0,1,.92.6C366.91,131.09,367,131.17,367,131.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.05,151.14s-.18.25-.6.61a11.15,11.15,0,0,1-2,1.36,8.26,8.26,0,0,1-3.45,1,6.21,6.21,0,0,1-4.3-1.31l.38-.06c-.16.23-.33.47-.51.71s-.39.45-.59.68a10.45,10.45,0,0,1-4.33,2.68,10.64,10.64,0,0,1-4.13.51,9.41,9.41,0,0,1-2.73-.63,3.57,3.57,0,0,1-.9-.48,15,15,0,0,0,3.65.74,10.92,10.92,0,0,0,4-.59,10.45,10.45,0,0,0,4.1-2.59c.19-.22.39-.42.56-.64l.49-.67.17-.24.21.18a5.84,5.84,0,0,0,3.95,1.25,8.21,8.21,0,0,0,3.32-.88C394.1,151.91,395,151.06,395.05,151.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.17,167.22s0,.11,0,.32a2.79,2.79,0,0,1-.39.83,4.6,4.6,0,0,1-2.8,1.85,8.75,8.75,0,0,1-4.94-.55,25.71,25.71,0,0,1-2.73-1.08,4.75,4.75,0,0,1-2.39-2.18c0-.1-.07-.2-.11-.28l.41.12a19.75,19.75,0,0,1-5.14,3.07,9,9,0,0,1-4.87.5,6.46,6.46,0,0,1-3-1.37,4,4,0,0,1-.63-.65c-.12-.16-.18-.25-.16-.26s.3.3.91.75a6.57,6.57,0,0,0,2.93,1.16,8.87,8.87,0,0,0,4.64-.57,20.2,20.2,0,0,0,5-3l.28-.22.13.34.09.24a4.27,4.27,0,0,0,2.13,1.93c.89.43,1.81.77,2.67,1.09a8.63,8.63,0,0,0,4.7.64,4.58,4.58,0,0,0,2.71-1.6A7.64,7.64,0,0,0,404.17,167.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.85,105.41s-.3,0-.82.15a3.92,3.92,0,0,0-1.94,1.24,5.42,5.42,0,0,0-1.31,3.31,16,16,0,0,0,.64,4.72l.07.28h-.29a9.9,9.9,0,0,0-6,1.82,7.69,7.69,0,0,0-3.29,6.06,7.08,7.08,0,0,0,2.51,5.77l.58.46h-.74a8.94,8.94,0,0,0-6.57,2.88,8.56,8.56,0,0,0-2.23,5.31,9.18,9.18,0,0,0,.58,3.82c.32.86.59,1.28.56,1.31a1.24,1.24,0,0,1-.22-.3,6.25,6.25,0,0,1-.5-.94,9,9,0,0,1-.74-3.91,8.81,8.81,0,0,1,2.23-5.59,9.32,9.32,0,0,1,6.89-3.08l-.15.45a7.57,7.57,0,0,1-2.72-6.19,7.76,7.76,0,0,1,1-3.73,8.8,8.8,0,0,1,2.49-2.72,10.25,10.25,0,0,1,6.3-1.85l-.22.27a15.71,15.71,0,0,1-.56-4.85,5.55,5.55,0,0,1,1.48-3.45,3.88,3.88,0,0,1,2.09-1.2,2.63,2.63,0,0,1,.63-.05C422.78,105.39,422.85,105.4,422.85,105.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.68,143s-.09.07-.28.17-.48.25-.87.4a12.55,12.55,0,0,1-3.49.78,13.85,13.85,0,0,1-5.44-.66,13.14,13.14,0,0,1-5.83-3.84l.39,0a11,11,0,0,1-7.8,5.33,8.35,8.35,0,0,1-8.62-4.6l.45,0a6.93,6.93,0,0,1-2.09,2.93,9.23,9.23,0,0,1-2.84,1.61,12.65,12.65,0,0,1-5.28.54,24,24,0,0,1-3.4-.56,7.22,7.22,0,0,1-1.18-.32,7.61,7.61,0,0,1,1.21.17,31.55,31.55,0,0,0,3.39.42,12.84,12.84,0,0,0,5.12-.63,7.48,7.48,0,0,0,4.61-4.32l.21-.58.24.56a7.9,7.9,0,0,0,8.11,4.28,10.62,10.62,0,0,0,7.46-5.06l.17-.29.22.26a12.87,12.87,0,0,0,5.6,3.76,13.61,13.61,0,0,0,5.28.75A15.86,15.86,0,0,0,453.68,143Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.47,168.3s0,.14-.2.32a1.79,1.79,0,0,1-1,.43,7.94,7.94,0,0,1-3.83-.64,9.41,9.41,0,0,1-4.4-3.69,9.61,9.61,0,0,1-1.26-6.89v-.05l.37.28a11.26,11.26,0,0,1-6.94.95,12.69,12.69,0,0,1-5.26-2.28,14.57,14.57,0,0,1-2.77-2.69,5.58,5.58,0,0,1-.77-1.19,20.68,20.68,0,0,0,3.75,3.58,12.6,12.6,0,0,0,5.13,2.1,11,11,0,0,0,6.62-.93l.47-.24-.09.52v.05a9.11,9.11,0,0,0,5.29,10.14,8.25,8.25,0,0,0,3.66.78A1.75,1.75,0,0,0,435.47,168.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,106a14.76,14.76,0,0,0-.79,5.32,11.87,11.87,0,0,0,10.89,11.17l.32,0-.1.31a15.25,15.25,0,0,0,.34,10,10.41,10.41,0,0,0,.7,1.55,1.31,1.31,0,0,0,.92.71.88.88,0,0,0,.69-.21c.12-.13.15-.23.17-.22s0,.11-.1.28a.92.92,0,0,1-.78.32,1.43,1.43,0,0,1-1.11-.74,10.26,10.26,0,0,1-.8-1.56,15.17,15.17,0,0,1-.51-10.27l.22.33a12.06,12.06,0,0,1-4.14-1.06,11.86,11.86,0,0,1-7.08-10.6,11.58,11.58,0,0,1,.56-4,8.09,8.09,0,0,1,.41-1A1.31,1.31,0,0,1,385,106Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.85,205.65v-2.76L369.11,194h0c-9.89-4.23-24-1.78-32.28,3.33l-7.19.19.07-.11c-8.23-6.49-22.1-7.8-32.86-3.11l.26,1.15h0c0,.07.07.24.12.48l.24,1c1.45,6.38,3.16,13.13,4.87,14.94,1.15,1.22,5,1.89,8.18,2.23,1.2.14,2.3.22,3.09.28.95.06,9.38.59,10.82-.71s4.24-11.7,5-14.83l7.37-.16c.88,2.47,2.38,13.55,5.92,15.78s19.06,1.56,20.82-1c1.25-1.83,5.58-12.7,6.56-16.13l.15-.3Zm-73.25,7c-1.57,1.24-18.36.37-20.35-1.73-1.68-1.78-3.75-10.88-4.53-14.3l0-.14c9.6-3.65,22.1-2.49,29.26,3C326.56,204.88,324.5,211.81,323.6,212.62Zm38.91,0c-1.1,1.62-15.44,2.94-19.09.64-2.54-1.59-3.88-9.33-5-13.77,8.09-4.84,21.92-6.88,30.7-2.52A94.17,94.17,0,0,1,362.51,212.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.87,200.41s1.51,10.85,4.63,11.35,6.84-15.89,6.84-15.89S341.85,197.75,339.87,200.41Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.92,196.93s1.51,12.32,4.63,12.82,9.39-14.51,9.39-14.51S301.9,194.27,299.92,196.93Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M396.12,397.65c-3.3-3.47-13.79-12.2-16.89-13.43s-12.75,21.44-13.37,27.38,2.74,13.74,6.92,18.95c6,7.44,20.39,16.57,25.85,19.11s21,11.43,30.4-8.56,8.2-19.83,10.85-28.07c4.09-12.76,7.48-37.92,9.54-53.23a250.82,250.82,0,0,0,1.71-42.19c-.66-12.39-4.14-23.54-12.47-31.21-7-6.45-30.36,50.07-30.36,50.57s-10.76,60.56-10.76,60.56",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.87,324.72s-2.24-3.84,5.87-5,13.94.15,15.76.93,12,10.37,12.8,12.23c2.2,5,5.88,20.15,5.88,20.15l5,7.07-11.75,21.09a34.07,34.07,0,0,0-3.51-3.54c-1.76-1.48-7.05-3.24-8.12-7.67a53.11,53.11,0,0,0-4.31-10.32s-19.72-4.27-21.47-5.16-1.62-3.54-1.62-3.54a49.31,49.31,0,0,1-6.14-1.07c-1.08-.44-3.59-4,.6-5.87s18.1-2.94,20-2.94,10.94,1.18,10.94,1.18-11.88-2.68-15.52-3-11.87-.11-13.19-.41c-1.65-.38-2.74-4.26.35-5.67,3.74-1.71,9.71-2.24,11.07-2.29,5.27-.19,17.91,1.75,17.91,1.75l-4.56-5.07a79.85,79.85,0,0,0-11.23-1.23A8.37,8.37,0,0,1,318.87,324.72Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,375.19l33.05,49.46s14-17.09,15-29.53l.62-6.11-37-36Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.56,351.05a33.8,33.8,0,0,1-3.59-.39c-2.2-.26-5.26-.53-8.65-.59s-6.46.13-8.67.32a33.67,33.67,0,0,1-3.6.29,3.84,3.84,0,0,1,.94-.24c.62-.13,1.51-.27,2.62-.41a62,62,0,0,1,8.72-.48,64.15,64.15,0,0,1,8.69.74c1.11.18,2,.35,2.6.49A3.77,3.77,0,0,1,337.56,351.05Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.81,393.61a7.63,7.63,0,0,1-1.22-.79l-3.2-2.3c-2.69-2-6.39-4.71-10.45-7.76a34.62,34.62,0,0,0-6-3.85,16.59,16.59,0,0,0-2.9-1,13.55,13.55,0,0,0-2.65-.44,6.15,6.15,0,0,0-3.69.86c-.77.49-1.11.89-1.15.86s.07-.12.23-.31a4.89,4.89,0,0,1,.81-.72,6.09,6.09,0,0,1,3.82-1.06,13.91,13.91,0,0,1,2.73.39,16.06,16.06,0,0,1,3,1,33,33,0,0,1,6.07,3.87c4.07,3.06,7.73,5.84,10.36,7.88l3.11,2.44A7.54,7.54,0,0,1,416.81,393.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.75,393.71c-.07.07-1.23-1.28-3.37-3.13a39.79,39.79,0,0,0-4-3,38.18,38.18,0,0,0-11-5,39.22,39.22,0,0,0-4.87-1c-2.82-.4-4.59-.39-4.59-.49a5.42,5.42,0,0,1,1.25-.07,12.76,12.76,0,0,1,1.46,0c.56,0,1.21.05,1.92.15a35.24,35.24,0,0,1,5,.92,39.67,39.67,0,0,1,5.81,2.07,40.41,40.41,0,0,1,5.38,3,35.4,35.4,0,0,1,3.95,3.13c.54.47,1,.95,1.38,1.35a14.28,14.28,0,0,1,1,1.08A5.38,5.38,0,0,1,432.75,393.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.16,286.75a11,11,0,0,1-1.15,1.18c-.39.36-.85.81-1.36,1.37s-1.13,1.14-1.73,1.88-1.3,1.49-2,2.38-1.37,1.85-2.09,2.87a51.58,51.58,0,0,0-6.8,14.7c-.31,1.21-.63,2.35-.83,3.45s-.41,2.11-.55,3-.23,1.79-.31,2.54-.14,1.39-.17,1.92a10.69,10.69,0,0,1-.15,1.65,9.79,9.79,0,0,1-.05-1.66c0-.53,0-1.18.08-1.94s.09-1.61.23-2.56.26-2,.49-3.08.5-2.26.8-3.49a48.86,48.86,0,0,1,6.87-14.84c.73-1,1.42-2,2.14-2.86s1.39-1.67,2-2.37,1.26-1.31,1.8-1.84a18.75,18.75,0,0,1,1.43-1.31A10,10,0,0,1,427.16,286.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.12,397.65c-3.3-3.47-13.79-12.2-16.89-13.43s-12.75,21.44-13.37,27.38,2.74,13.74,6.92,18.95c6,7.44,20.39,16.57,25.85,19.11s21,11.43,30.4-8.56,8.2-19.83,10.85-28.07c4.09-12.76,7.48-37.92,9.54-53.23a250.82,250.82,0,0,0,1.71-42.19c-.66-12.39-4.14-23.54-12.47-31.21-7-6.45-30.36,50.07-30.36,50.57s-10.76,60.56-10.76,60.56",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.87,324.72s-2.24-3.84,5.87-5,13.94.15,15.76.93,12,10.37,12.8,12.23c2.2,5,5.88,20.15,5.88,20.15l5,7.07-11.75,21.09a34.07,34.07,0,0,0-3.51-3.54c-1.76-1.48-7.05-3.24-8.12-7.67a53.11,53.11,0,0,0-4.31-10.32s-19.72-4.27-21.47-5.16-1.62-3.54-1.62-3.54a49.31,49.31,0,0,1-6.14-1.07c-1.08-.44-3.59-4,.6-5.87s18.1-2.94,20-2.94,10.94,1.18,10.94,1.18-11.88-2.68-15.52-3-11.87-.11-13.19-.41c-1.65-.38-2.74-4.26.35-5.67,3.74-1.71,9.71-2.24,11.07-2.29,5.27-.19,17.91,1.75,17.91,1.75l-4.56-5.07a79.85,79.85,0,0,0-11.23-1.23A8.37,8.37,0,0,1,318.87,324.72Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,375.19l33.05,49.46s14-17.09,15-29.53l.62-6.11-37-36Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.56,351.05a33.8,33.8,0,0,1-3.59-.39c-2.2-.26-5.26-.53-8.65-.59s-6.46.13-8.67.32a33.67,33.67,0,0,1-3.6.29,3.84,3.84,0,0,1,.94-.24c.62-.13,1.51-.27,2.62-.41a62,62,0,0,1,8.72-.48,64.15,64.15,0,0,1,8.69.74c1.11.18,2,.35,2.6.49A3.77,3.77,0,0,1,337.56,351.05Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.81,393.61a7.63,7.63,0,0,1-1.22-.79l-3.2-2.3c-2.69-2-6.39-4.71-10.45-7.76a34.62,34.62,0,0,0-6-3.85,16.59,16.59,0,0,0-2.9-1,13.55,13.55,0,0,0-2.65-.44,6.15,6.15,0,0,0-3.69.86c-.77.49-1.11.89-1.15.86s.07-.12.23-.31a4.89,4.89,0,0,1,.81-.72,6.09,6.09,0,0,1,3.82-1.06,13.91,13.91,0,0,1,2.73.39,16.06,16.06,0,0,1,3,1,33,33,0,0,1,6.07,3.87c4.07,3.06,7.73,5.84,10.36,7.88l3.11,2.44A7.54,7.54,0,0,1,416.81,393.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.3,337a4.36,4.36,0,0,1-.05.8c-.06.58-.15,1.34-.25,2.3-.25,2.05-.6,4.93-1,8.45l-3.57,27.85c-.29,2.19-.57,4.33-.84,6.38l-.25-.29c9.5,0,17.77,2.38,23,5.29a26.26,26.26,0,0,1,5.71,4.08,16.08,16.08,0,0,1,1.31,1.37,3.22,3.22,0,0,1,.41.51s-.63-.65-1.85-1.74a28.09,28.09,0,0,0-5.74-3.92c-5.22-2.8-13.42-5.07-22.84-5.08H402l0-.29c.27-2.05.55-4.19.83-6.38,1.45-10.84,2.76-20.66,3.72-27.82.5-3.52.9-6.39,1.19-8.43.14-1,.26-1.72.35-2.29A4.08,4.08,0,0,1,408.3,337Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.16,286.75a11,11,0,0,1-1.15,1.18c-.39.36-.85.81-1.36,1.37s-1.13,1.14-1.73,1.88-1.3,1.49-2,2.38-1.37,1.85-2.09,2.87a51.58,51.58,0,0,0-6.8,14.7c-.31,1.21-.63,2.35-.83,3.45s-.41,2.11-.55,3-.23,1.79-.31,2.54-.14,1.39-.17,1.92a10.69,10.69,0,0,1-.15,1.65,9.79,9.79,0,0,1-.05-1.66c0-.53,0-1.18.08-1.94s.09-1.61.23-2.56.26-2,.49-3.08.5-2.26.8-3.49a48.86,48.86,0,0,1,6.87-14.84c.73-1,1.42-2,2.14-2.86s1.39-1.67,2-2.37,1.26-1.31,1.8-1.84a18.75,18.75,0,0,1,1.43-1.31A10,10,0,0,1,427.16,286.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.43,362.29s-8.47-20.94-6.83-28a1.94,1.94,0,0,1,1.88-1.48h0a1.92,1.92,0,0,1,1.71,1l11,21.21s1.46-3.88,4.63-5.24a106.41,106.41,0,0,1,10.25-3.21l9.94,1.24a2.09,2.09,0,0,1,1.26,3.52,9,9,0,0,1-6,2.43c-7.21.6-9.09,2.26-9.09,2.26l-3.6,6.2s7.6-5.2,10-5.4c1.87-.15,12.22-.37,16.71-.46a3.91,3.91,0,0,1,3.81,2.61c.47,1.43.14,3-3.06,3.85,0,0,3.51,1.82-1.26,4.2a66.14,66.14,0,0,1-9,3.6l-6.8,4.59-11.39,8-13.39-9.19s-4.77-5.06-1.8-9.29A11,11,0,0,0,253.43,362.29Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.62,369.19s6.38,5.44,7.78,8.84,2.6,6.85.41,15.05-20.53,0-20.53,0c-.51-3.36-4.61-7.4-9.19-11.54l17.12-12.65Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,352.12a10.79,10.79,0,0,1-1,1.67c-.67,1-1.55,2.43-2.51,4-1.91,3.18-3.53,5.72-3.67,5.63a8.07,8.07,0,0,1,.86-1.78c.58-1.07,1.4-2.53,2.36-4.12C260.89,354.33,262.86,352,263,352.12Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.29,362.68a3.66,3.66,0,0,1-1,.16l-2.78.23c-2.35.18-5.61.36-9.18.57-3.68,0-6.16,2.44-8,3.85a29.44,29.44,0,0,1-3,2.4,4.59,4.59,0,0,1,.69-.76c.47-.46,1.16-1.13,2-1.92a26.86,26.86,0,0,1,3.28-2.58,8.92,8.92,0,0,1,2.26-1.08,14.13,14.13,0,0,1,2.64-.43c3.6-.21,6.84-.34,9.2-.42,1.17,0,2.13-.06,2.79-.06A4.06,4.06,0,0,1,296.29,362.68Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,362.34c.09.12-.5.7-1.1,1.52s-1,1.56-1.12,1.51,0-.93.7-1.82S268.88,362.22,269,362.34Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.16,367.54a6.66,6.66,0,0,1-1.73.84c-1.09.44-2.63,1-4.32,1.58-3.38,1.18-6,2.43-6.07,2.3a22.2,22.2,0,0,1,5.89-2.79c1.7-.61,3.26-1.09,4.38-1.44A7.66,7.66,0,0,1,294.16,367.54Z",
    style: {
      fill: "#ff9a6c"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoon);
export default __webpack_public_path__ + "static/media/soon.13dbb1e1579ae226fe7d7371cfd231f4.svg";
export { ForwardRef as ReactComponent };